import React, { FC } from 'react'
import { Text } from '@afterpaytouch/core'
import { useConsumerSizes } from '../../../../../utils/responsive'
import { useTranslation } from 'next-i18next'

const I18N_NAMESPACE = ['dispute']

interface DetailRowProps {
  label: string
  value: string
}

const DetailRow: FC<DetailRowProps> = ({ label, value }) => {
  const { textSize } = useConsumerSizes()

  return (
    <div className='flex justify-between pt-3'>
      <Text size={textSize}>{label}</Text>
      <Text size={textSize}>{value}</Text>
    </div>
  )
}

export interface DisputeItemDetailsProps {
  itemName: string
  disputeReason: string
  disputeDescription: string
  disputeAmount: string
}

export const DisputeItemDetails: FC<DisputeItemDetailsProps> = ({ itemName, disputeReason, disputeDescription, disputeAmount }) => {
  const { t } = useTranslation(I18N_NAMESPACE)

  return (
    <>
      <DetailRow label={t('dispute:section75DisputeModal:review:disputeItem')} value={itemName} />
      <DetailRow label={t('dispute:section75DisputeModal:review:disputeReason')} value={disputeReason} />
      <DetailRow label={t('dispute:section75DisputeModal:review:disputeDescription')} value={disputeDescription} />
      <DetailRow label={t('dispute:section75DisputeModal:review:disputeAmount')} value={disputeAmount} />
    </>
  )
}
